import { render, staticRenderFns } from "./KabIntanJaya.vue?vue&type=template&id=1db7fc7e"
import script from "./KabIntanJaya.vue?vue&type=script&lang=js"
export * from "./KabIntanJaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports